import extend from './src/extend'
import waitAll from './src/waitAll'
import firstLowerCase from './src/firstLowerCase'
import firstUpperCase from './src/firstUpperCase'
import cookie from './src/cookie'
import crypto from './src/crypto'
import md5 from './src/md5'
import base64 from './src/base64'
import each from './src/each'
import isArray from './src/isArray'
import randomNum from './src/randomNum'
import startsWith from './src/startsWith'
import endsWith from './src/endsWith'
import selectJSON from './src/selectJSON'
import parseUrl from './src/parseUrl'
import loaders from './src/loader'
import utf8 from './src/utf8'
import zip_inflate from './src/rawinflate'
import zip_deflate from './src/rawdeflate'
import dateFormat from './src/dateFormat'
import uuid from './src/uuid'
import isRightMobileNum from './src/isRightMobileNum'
import EventExtend from './src/evt-ext'
import humanReadableSize from './src/humanReadableSize'
import mediaType from './src/mediatype'
import Buffer from './src/Buffer'
import WildEmitter from './src/WildEmitter'
import mockconsole from './src/mockconsole'
import md5utf_8 from './src/md5utf_8'
import flattenArray from './src/flattenArray'
import getQueryString from './src/getQueryString'
import Export2Excel from './src/Export2Excel'
import bus from './src/bus'

let global = window || {};
const utils = {
    global,
    extend,
    waitAll,
    firstLowerCase,
    firstUpperCase,
    cookie,
    crypto,
    md5,
    base64,
    each,
    isArray,
    randomNum,
    startsWith,
    endsWith,
    selectJSON,
    parseUrl,
    ...loaders,
    ...utf8,
    zip_inflate: new zip_inflate(this), //解压
    zip_deflate, //压缩
    ZipInflate: zip_inflate,
    dateFormat,
    uuid,
    isRightMobileNum,
    EventExtend,
    humanReadableSize,
    ...mediaType,
    Buffer,
    WildEmitter,
    mockconsole,
    md5utf_8,
    flattenArray,
    getQueryString,
    Export2Excel,
    bus
}

export default utils